// extracted by mini-css-extract-plugin
export default {"About":"About_About__Q9mIv","content":"About_content__saf+1"};